import { render, staticRenderFns } from "./busType-add.vue?vue&type=template&id=39a91ec8&scoped=true&"
import script from "./busType-add.vue?vue&type=script&lang=js&"
export * from "./busType-add.vue?vue&type=script&lang=js&"
import style0 from "./busType-add.vue?vue&type=style&index=0&id=39a91ec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a91ec8",
  null
  
)

export default component.exports